import { ChatBotFeedbackPage } from '@/Workspaces/ChatBotHistory/ChatBotFeedbackPage'
import { createFileRoute, useParams } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/botProvider/$botProviderId/feedback',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botProviderId } = useParams({ from: "/workspace/$workspaceId/botProvider/$botProviderId/feedback" })
  return <ChatBotFeedbackPage workspaceId={workspaceId} botProviderId={botProviderId} />
}
